import React from 'react';
import {
  ILinkContent,
  IVerticalAnchorsMenuProps,
} from '../../../VerticalAnchorsMenu.types';
import VerticalAnchorsMenuCommonSkin from '../VerticalAnchorsMenuCommonSkin';
import styles from './styles/skins.scss';

const linkContent = (props: ILinkContent) => {
  const { id, label } = props;
  return (
    <>
      <svg className={styles.symbol} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
      </svg>
      <span id={id} className={styles.hiddenText}>
        {label}
      </span>
    </>
  );
};

const VerticalAnchorsMenuSymbolSkin: React.FC<
  IVerticalAnchorsMenuProps
> = props => {
  return (
    <VerticalAnchorsMenuCommonSkin
      {...props}
      style={styles}
      skin="VerticalAnchorsMenuSymbolSkin"
      linkContent={linkContent}
    />
  );
};

export default VerticalAnchorsMenuSymbolSkin;
